// @flow
import { createSelector } from "reselect";
import { getWidgetConfig } from "root/selectors";
import {
	getTabContext,
	selectTabContextItems,
	selectTabIsIdSelected,
	selectTabReachedMaxSelectionWithContext,
	selectTabCurrentContext,
	selectTabMultipleIdsInRange,
	selectTabAvailableUntilMax,
} from "../../common/selectors";
import { selectBatchStartCounter } from "../../../root/selectors";

const TAB = "instagram";

const getContext = getTabContext(TAB);
const selectContextItems = selectTabContextItems(TAB);
const selectReachedMaxSelection = selectTabReachedMaxSelectionWithContext(TAB);
const selectIsIdSelected = selectTabIsIdSelected(TAB);
const selectCurrentContext = selectTabCurrentContext(TAB);
const selectMultipleIdsInRange = selectTabMultipleIdsInRange(TAB);
const selectAvailableUntilMax = selectTabAvailableUntilMax(TAB);

const selectAuthData: Object => Object = createSelector(
	getWidgetConfig,
	(state: Object) => !!state.instagram.token,
	(widgetConfig: Object, isAuth) => ({
		isAuth,
		cloudName: widgetConfig.cloudName,
	}),
);

const selectTabData: Object => Object = createSelector(
	getWidgetConfig,
	(state: Object) => ({
		isLoggedIn: !!state.instagram.token,
		currentContext: getContext(state).context,
		account: state.instagram.account,
		listeningForAuth: state.instagram.listeningForAuth,
	}),
	selectBatchStartCounter,
	(widgetConfig, instaData, batchStartCounter) => ({
		cloudName: widgetConfig.cloudName,
		isMultiple: widgetConfig.multiple,
		isLoggedIn: instaData.isLoggedIn,
		currentContext: instaData.currentContext,
		userName: instaData.account && instaData.account.name,
		listeningForAuth: instaData.listeningForAuth,
		batchStartCounter,
	}),
);

const selectExtInstagramServer: Object => string = createSelector(
	getWidgetConfig,
	(config) => config.instagramServer,
);

export {
	selectAuthData,
	selectTabData,
	selectContextItems,
	selectIsIdSelected,
	selectReachedMaxSelection,
	selectCurrentContext,
	selectMultipleIdsInRange,
	selectAvailableUntilMax,
	selectExtInstagramServer,
};
